import React from 'react';
import ReactDOM from 'react-dom';
import LayoutAwareApp from './LayoutAwareApp';
import {LayoutMode} from './types';

export class App extends React.Component {
    render() {

        return (
            <>
                {document.getElementById('clinic-CDP-buy-box-react-root-desktop') &&
                    ReactDOM.createPortal(<LayoutAwareApp layoutMode={LayoutMode.DESKTOP} />, document.getElementById('clinic-CDP-buy-box-react-root-desktop')!)
                }
                {document.getElementById('clinic-CDP-buy-box-react-root-mobile') &&
                    ReactDOM.createPortal(<LayoutAwareApp layoutMode={LayoutMode.MOBILE} />, document.getElementById('clinic-CDP-buy-box-react-root-mobile')!)
                }
                {document.getElementById('offer-page-react-root') &&
                    ReactDOM.createPortal(<LayoutAwareApp layoutMode={LayoutMode.DESKTOP} />, document.getElementById('offer-page-react-root')!)
                }
            </>
        );
    }
}

export default App;
